import "./index.scss";
import AnimatedLetters from "../AnimatedLetters";
import { useEffect, useState } from "react";
import { Planet } from "react-planet";
import {
    AiOutlineHtml5,
    AiOutlineDotChart,
    AiOutlineRobot,
} from "react-icons/ai";
import {
    DiSass,
    DiReact,
    DiCss3,
    DiNodejsSmall,
    DiMysql,
} from "react-icons/di";
import {
    SiExpress,
    SiFirebase,
    SiSpringboot,
    SiMongodb,
    SiPandas,
    SiNumpy,
    SiSelenium,
} from "react-icons/si";

const skill_items = [
    {
        main_item: "Web: Frontend",
        item_list: [
            ["Sass", <DiSass />],
            ["React JS", <DiReact />],
            ["HTML", <AiOutlineHtml5 />],
            ["CSS", <DiCss3 />],
        ],
    },
    {
        main_item: "Web: Backend",
        item_list: [
            ["Node JS", <DiNodejsSmall />],
            ["Express", <SiExpress />],
            ["Firebase", <SiFirebase />],
            ["Spring Boot", <SiSpringboot />],
        ],
    },
    {
        main_item: "Databases",
        item_list: [
            ["Mongo DB", <SiMongodb />],
            ["MySQL", <DiMysql />],
        ],
    },
    {
        main_item: "Data Analysis",
        item_list: [
            ["Pandas", <SiPandas />],
            ["NumPy", <SiNumpy />],
            ["Seaborn", <AiOutlineDotChart />],
        ],
    },
    {
        main_item: "Automation",
        item_list: [
            ["Selenium", <SiSelenium />],
            ["RPA", <AiOutlineRobot />],
        ],
    },
];

const Skills = () => {
    const [letterClass, setLetterClass] = useState("text-animate");
    const [openIndex, setOpenIndex] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 4000);
        return () => {
            console.log("This will be logged on unmount");
        };
    }, []);

    return (
        <div className="container skills-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                        strArray={Array.from("Technical ")}
                        idx={15}
                        letterClass={letterClass}
                    />
                </h1>
                <h1>
                    <AnimatedLetters
                        strArray={Array.from("Skills")}
                        idx={24}
                        letterClass={letterClass}
                    />
                </h1>
                <div className="subtext-zone">
                    <div className="planets-container">
                        {skill_items.map((item, idx) => (
                            <Planet
                                mass={5}
                                tension={500}
                                friction={30}
                                orbitStyle={(defaultStyle) => ({
                                    ...defaultStyle,
                                    borderWidth: 0,
                                })}
                                centerContent={
                                    <div
                                        className="planet-center-content"
                                        onClick={(idx) => setOpenIndex(idx)}
                                    >
                                        {item["main_item"]}
                                    </div>
                                }
                                open={Number(openIndex) === Number(idx)}
                                autoClose
                                orbitRadius={125}
                                rotation={item.item_list.length === 2 && 90}
                            >
                                {item["item_list"].map((i) => (
                                    <div className="planet-orbital-content">
                                        {i[1]}
                                        <p className="planet-orbital-content-tooltip-disabled">
                                            {i[0]}
                                        </p>
                                    </div>
                                ))}
                            </Planet>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
